window.addEventListener('load', (event) => {
  var swiper = new Swiper(".product-thumbs_slider", {
    loop: true,
    direction: "vertical",
    slidesPerView: 5,
    spaceBetween: 10,
    navigation: {
      nextEl: ".arrow-next",
      prevEl: ".arrow-prev",
    }
  });

  var swiper2 = new Swiper(".product_main-slider", {
    loop: true,
    navigation: {
      nextEl: ".main_slider-arrow.arrow-next",
      prevEl: ".main_slider-arrow.arrow-prev",
    },
    thumbs: {
      swiper: swiper
    },
    pagination: {
      el: ".product-thumbs-pagination",
      clickable: true,
    }
  });

  var swiper3 = new Swiper(".extras_subscription-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".subscribe-next",
      prevEl: ".subscribe-prev",
    },
    
  });

  const tell_me_about_tabs = document.querySelectorAll('.tell-me-about-tabs .title-tabs .tab');
  const tell_me_about_tabs_content = document.querySelectorAll('.tell-me-about-tabs .tabs-content .info-tab');

  tell_me_about_tabs.forEach((element, index) => {
    element.addEventListener('click', () => {
      // Quita la clase "active" de todos los elementos de tell_me_about_tabs
      tell_me_about_tabs.forEach(tab => {
        tab.classList.remove('active');
      });

      // Agrega la clase "active" al elemento clickeado
      element.classList.add('active');

      // Quita la clase "active" de todos los elementos de tell_me_about_tabs_content
      tell_me_about_tabs_content.forEach(content => {
        content.classList.remove('active');
      });

      // Agrega la clase "active" al contenido correspondiente
      tell_me_about_tabs_content[index].classList.add('active');
    });
  });

  function setupModalTrigger(triggerSelectors, modalSelector, contentSelector) {
    const modals = document.querySelectorAll(modalSelector);
    const modalContent = document.querySelector(contentSelector);
  
    triggerSelectors.forEach((triggerSelector) => {
      const triggers = document.querySelectorAll(triggerSelector);
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          modals.forEach((modal) => modal.classList.add('active'));
        });
      });
    });
  
    document.addEventListener('click', (event) => {
      if (!modalContent.contains(event.target) && !triggerSelectors.some((selector) => {
        const triggers = document.querySelectorAll(selector);
        return Array.from(triggers).some((trigger) => trigger.contains(event.target));
      })) {
        modals.forEach((modal) => modal.classList.remove('active'));
      }
    });
  
    const closeModal = modalContent.querySelector('.modal-close');
    closeModal.addEventListener('click', () => {
      modals.forEach((modal) => modal.classList.remove('active'));
    });
  }
  
  // Ejemplo de uso:
  setupModalTrigger(['.subscribe_and_save-section .text_how-subscriptions'], '.subscribe_and_save-section-modal', '.modal-content');
  setupModalTrigger(['.subscribe_and_save-section .subscribe_and_save-list .btn-modal_list'], '.subscribe_and_save-list-modal', '.list-modal-content');
  

  // const dropdownItems = document.querySelectorAll('.dropdown-section .dropdown-item');
  // dropdownItems.forEach(item => {
  //   const dropdownItemsBtn = item.querySelector('.dropdown-item_btn');
  //   const dropdownItemsText = item.querySelector('dropdown-info');
  //   const maxHeight = dropdownItemsText.scrollHeight + 'px';

  //   dropdownItemsBtn.addEventListener('click', () => {
  //       if (item.classList.contains('active')) {
  //           item.classList.remove('active');
  //           dropdownItemsText.style.maxHeight = '0';
  //       } else {
  //           dropdownItems.forEach(otherItem => {
  //               otherItem.classList.remove('active');
  //               dropdownItemsText.style.maxHeight = "0"
  //           });
  //           item.classList.add('active');
  //           dropdownItemsText.style.maxHeight = maxHeight;
  //       }
  //     });
  // });

  let buttomHeader = document.querySelector(`.button-movil`);  
  let NewHeader = document.querySelector(`.global-ctn-new-header`);  
  let bar = document.getElementById("qab_container");  
  let btnClose = document.getElementById("qab_close");
  
  function updateHeaderPosition() {  
    let heightBar = bar.offsetHeight;  
    NewHeader.style.top = `${heightBar}px`;  
  }  

  btnClose.addEventListener("click", ()=>{
    NewHeader.style.top = `0px`;
  })
  
  updateHeaderPosition();  
  
  window.addEventListener('resize', updateHeaderPosition);

  buttomHeader.addEventListener('click', ()=>{
    buttomHeader.classList.toggle(`active`)
    NewHeader.classList.toggle(`dropdown`)
  })

  window.addEventListener("scroll", ()=>{
    NewHeader.classList.toggle("active", window.scrollY>0)
  })

  let buttonModal = document.querySelector('.button-modal')
  let windowModal = document.querySelector('.modal-about-us')
  let overlayModal = document.querySelector('.overlay-modal')
  let closeModal = document.querySelector('.button-close-modal')

  buttonModal.addEventListener('click', ()=>{
    windowModal.classList.add(`active`)
    overlayModal.classList.add(`active`)
    buttomHeader.classList.toggle(`active`)
    NewHeader.classList.remove(`dropdown`)
  })

  closeModal.addEventListener('click', ()=>{
    windowModal.classList.remove(`active`)
    overlayModal.classList.remove(`active`)
  })

  overlayModal.addEventListener('click', ()=>{
    windowModal.classList.remove(`active`)
    overlayModal.classList.remove(`active`)
  })
});

document.addEventListener('DOMContentLoaded', function() {  
  const inputOneTimePurchase = document.querySelectorAll('.input-one-time-purchase');  
  const subscribeAndSaveSections = document.querySelectorAll('.subscribe_and_save-section-widget');  

  inputOneTimePurchase.forEach((item, index) => {  
      item.addEventListener('click', () => {  
          inputOneTimePurchase.forEach((input) => {  
              input.classList.remove('active');  
          });  

          item.classList.add('active');  

          const form = document.querySelector('product-form');  
          if (form) {  
              form.clearAdditionalProducts();  
          }  

          subscribeAndSaveSections.forEach((section) => {  
              section.classList.remove('active');  
              section.classList.add('remove'); 
          });  

          if (subscribeAndSaveSections[index]) {  
              subscribeAndSaveSections[index].classList.add('active');
              if(index == 0){
                subscribeAndSaveSections[index].querySelector('.delivery-item input').click();
              }  
              subscribeAndSaveSections[index].classList.remove('remove'); // Remover 'remove' de la sección activa  
          }  
      });  
  });  

  let variables = document.querySelectorAll('.variations-container .ctn-price');

  variables.forEach((element) => {
      element.addEventListener('click', () => {
        variables.forEach((variable) => {
          variable.classList.remove('active');
        });
        element.classList.add('active');
    });
  });
  
  
});

